// extracted by mini-css-extract-plugin
export var latestResources = "style-module--latest-resources--f5491";
export var latestResources__header = "style-module--latest-resources__header--8ca96";
export var latestResources__link = "style-module--latest-resources__link--0bbbe";
export var latestResources__posts = "style-module--latest-resources__posts--18ad8";
export var latestResources__wrapper = "style-module--latest-resources__wrapper--0bdb2";
export var latestResources__wrapperouter = "style-module--latest-resources__wrapperouter--68a12";